import { useEffect, useMemo, useState } from "react";
import { SOURCE_OPTIONS } from "~/constants/dropdowns/leads/SourceOptions";
import { apiFetch } from "~/lib/fetchClient";

const useLeadSources = () => {
  const [customSources, setCustomSources] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let aborted = false;
    const req = apiFetch.get("/lead_sources");

    const fetchSources = async () => {
      try {
        const response = await req;
        const sources = response.map((source) => ({
          value: source.name,
          label: source.name,
        }));
        setCustomSources(sources);
      } catch {
        if (!aborted) {
          setCustomSources([]);
        }
      } finally {
        if (!aborted) {
          setLoading(false);
        }
      }
    };

    fetchSources();

    return () => {
      aborted = true;
      req.abort();
    };
  }, []);

  const options = useMemo(() => {
    const merged = [...customSources, ...SOURCE_OPTIONS];
    const unique = Array.from(
      new Map(merged.map((opt) => [opt.value.toLowerCase(), opt])).values(),
    );
    return unique.sort((a, b) =>
      a.value.toLowerCase().localeCompare(b.value.toLowerCase()),
    );
  }, [customSources]);

  return { options, loading };
};

export default useLeadSources;
